import { boolean, defineAction, object } from '~/prix'
import systemCheckAction from './overviewStats.action.json' with { type: 'json' }

const systemCheckDefinition = defineAction({
  ...systemCheckAction,

  input: object({}),
  output: object({
    ok: boolean(),
  }),
})

export default systemCheckDefinition
